module.exports = __webpack_public_path__ + "static/media/Yogi_sad2.5b8483e8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/Yogi_sad2.png
// module id = 623
// module chunks = 0